(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/shared-utils.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/shared-utils.js');

'use strict';

const storeCustomerType = (customerType, callback) => {
  svs.components.Storage.browser.set('customerType', 'customer_registration', customerType, svs.components.Storage.constants.EXPIRES_1H, callback);
};
const saveRefForGUITest = ref => {
  try {
    let input = document.getElementById('token-auto-test');
    if (input) {
      input.value = ref;
      return;
    }

    input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'token-auto-test');
    input.setAttribute('id', 'token-auto-test');
    input.setAttribute('value', ref);
    document.body.appendChild(input);
  } catch (error) {
  }
};
svs.playerLoginReact.sharedComponents.sharedUtils = {
  storeCustomerType,
  saveRefForGUITest
};

 })(window);